export default {
    init() {
        this.saveFromModal();
    },
    saveCash($amount, $subject, $description, id_modal = null, id_container = null) {
        $.ajax({
            type: 'POST',
            url: '/cash/save',
            data: ({
                amount: $amount,
                subject: $subject,
                description: $description,
            }),
            success: function (response) {
                if (id_modal !== null && id_container !== null) {
                    $(id_modal).modal('hide');
                    $(id_container).html(response.view);
                }
            },
        });
    },
    saveFromModal() {
        let $this = this;
        $('body').on('click', '.add-new-cash', function () {
            $('#add-new-cash-form')[0].reset();
        });
        $('body').on('submit', '#add-new-cash-form', function (e) {
            e.preventDefault();
            let amount = $('input[name="amount"]').val();
            let subject = $('select[name="subject"]').val();
            let description = $('textarea[name="description"]').val();
            $this.saveCash(amount, subject, description, '#add-new-cash', '#cash');
        });
    },
    saveFromOrder($order_id) {
        let $this = this;
        $.ajax({
            type: 'GET',
            url: '/get_total_by_order_id',
            data: ({
                order_id: $order_id,
            }),
            success: function (response) {
                $this.saveCash(response.total, 'order', 'Pay order #' + $order_id);
                $.ajax({
                    type: 'POST',
                    url: '/change_order',
                    data: ({
                        status: 'Paid',
                        order_id: $order_id,
                    }),
                    success: function() {
                        window.open('/print-order-receipt/' + $order_id);
                    }
                });
            }
        });
    }
}
